document.addEventListener('DOMContentLoaded', function () {
    // variables
    const headerAnnouncement = document.querySelector('.announcemnet-bar-custom');
    const headerCustom = document.querySelector('.header-custom');
    // Guarda la posición del scroll anterior
    let lastScrollTop = 0;

    // Función que se ejecuta cuando se hace scroll
    window.addEventListener('scroll', () => {
        const st = window.scrollY;
        const rect = headerCustom.getBoundingClientRect();
        const calcManuTop = rect.top + headerCustom.offsetHeight

        if (st > lastScrollTop && calcManuTop < 0) {
            headerAnnouncement.parentElement.classList.add('hidden');
            headerCustom.parentElement.classList.add('hidden');
        } else {
            headerAnnouncement.parentElement.classList.remove('hidden');
            headerCustom.parentElement.classList.remove('hidden');
        }

        if (st < lastScrollTop) {
            // Scroll hacia abajo: oculta el header
            headerAnnouncement.parentElement.classList.add('sticky');
            headerCustom.parentElement.classList.add('sticky');
            headerCustom.parentElement.style.top = headerAnnouncement.offsetHeight + 'px';
        } else {
            // Scroll hacia arriba: muestra el header
            headerAnnouncement.parentElement.classList.remove('sticky');
            headerCustom.parentElement.classList.remove('sticky');
        }

        lastScrollTop = st;

        if (lastScrollTop === 0) {
            headerAnnouncement.parentElement.classList.remove('sticky');
            headerCustom.parentElement.classList.remove('sticky');
            headerAnnouncement.parentElement.classList.remove('hidden');
            headerCustom.parentElement.classList.remove('hidden');
        }
    });
});
